import actionTypes from "./actionTypes";

export const changePassword = data => {
  return {
    type: actionTypes.CHANGE_PASSWORD,
    payload: data
  };
};